import { render, staticRenderFns } from "./DetailsSection.vue?vue&type=template&id=99b0fafe&"
import script from "./DetailsSection.vue?vue&type=script&lang=js&"
export * from "./DetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports